import { render, staticRenderFns } from "./docrole.vue?vue&type=template&id=93122a2a&scoped=true&"
import script from "./docrole.vue?vue&type=script&lang=js&"
export * from "./docrole.vue?vue&type=script&lang=js&"
import style0 from "./docrole.vue?vue&type=style&index=0&id=93122a2a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93122a2a",
  null
  
)

export default component.exports